export const RECTANGLE_CHART_HEIGHT = 8;

export const CIRCLE_ICON_RADIUS = 12;

/** Расстояние на которое иконки перекрывают друг друга, если надо отрисовать две иконки для одной точки */
export const OVERLAY_ICONS_SIZE = 4;
